'use strict';

exports.__esModule = true;
var isString = exports.isString = function (value) {
  return typeof value === 'string';
};

var normalizeAnimation = exports.normalizeAnimation = function (props) {
  var result = null;
  if (!props || typeof props !== 'object') {
    return result;
  }
  Object.keys(props).forEach(function (key) {
    if (key && key.length > 0) {
      var name = key[0].toUpperCase() + key.slice(1);
      result = result || {};
      result['animation' + name] = props[key];
    }
  });
  return result;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-hold-animation/lib/utils.js
// module id = 195
// module chunks = 0